import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from 'wouter';
import { useState } from 'react';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export default function NossosEventos() {
  const [hoveredCard, setHoveredCard] = useState<string | null>(null);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        {/* Hero */}
        <section className="relative text-primary-foreground h-[265px] flex items-center" style={{backgroundImage: "url('/images/pages/hero-colorido.webp')", backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: "0 0 96px 0", overflow: "hidden", boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)"}}>
          <div className="absolute inset-0" style={{background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 0.2) 70%, rgba(0, 0, 0, 0) 100%)"}}></div>
          <div className="container relative z-10">
            <h1 className="text-4xl md:text-5xl text-center mb-4" style={{fontFamily: "'Suez One'"}}>
              Nossos Eventos
            </h1>
          </div>
        </section>

        {/* Intro */}
        <section className="py-16 md:py-24 bg-background">
          <div className="container max-w-4xl text-center">
            <p className="text-sm font-semibold text-secondary mb-4 uppercase">
              Para todos os clientes Fercci
            </p>
            <h2 className="text-4xl md:text-5xl mb-6 text-primary" style={{fontFamily: "'Suez One'"}}>
              Experiências que vão muito além da compra
            </h2>
            <p className="text-lg text-muted-foreground" style={{lineHeight: "1.6"}}>
              Conecte-se com o futuro da agricultura, participando de eventos exclusivos para nossos 
              clientes e parceiros, onde trazemos informações atualizadas sobre o mercado e as novidades 
              que podem melhorar a performance da sua lavoura.
            </p>
          </div>
        </section>

        {/* Safra Financeira */}
        <section className="py-16 md:py-24 bg-secondary text-secondary-foreground">
          <div className="container">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl md:text-5xl mb-6 text-accent" style={{fontFamily: "'Suez One'"}}>
                  Safra Financeira
                </h2>
                <p className="text-base md:text-lg mb-4" style={{lineHeight: "1.6"}}>
                  A Safra Financeira é um evento anual realizado pela Fercci em parceria com a Yara 
                  Fertilizantes e parceiros, focado em trazer insights estratégicos sobre o mercado de 
                  commodities e fertilizantes.
                </p>
                <p className="text-base md:text-lg mb-4" style={{lineHeight: "1.6"}}>
                  Voltado para clientes selecionados e parceiros, o evento conta com palestras de 
                  especialistas que discutem tendências do agronegócio e ajudam na tomada de decisões 
                  mais seguras.
                </p>
                <p className="text-base md:text-lg" style={{lineHeight: "1.6"}}>
                  Além disso, a Safra Financeira é um momento de demonstração de novos produtos e 
                  tecnologias inovadoras, oferecendo networking e conhecimento essencial para quem 
                  busca se destacar no setor agrícola.
                </p>
              </div>
              
              <div className="flex justify-center">
                <iframe loading="lazy"
                  width="100%"
                  height="400"
                  src="https://www.youtube.com/embed/33HlkKNL_yM"
                  title="Safra Financeira"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{borderRadius: '12px', maxWidth: '500px'}}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Feira Agrobrasília */}
        <section className="py-16 md:py-24 bg-primary text-primary-foreground">
          <div className="container">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1 flex justify-center">
                <iframe loading="lazy"
                  width="100%"
                  height="500"
                  src="https://www.youtube.com/embed/FZyHr-Boa5c"
                  title="Agrobrasília"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{borderRadius: '12px', maxWidth: '300px'}}
                />
              </div>
              
              <div className="order-1 lg:order-2">
                <h2 className="text-4xl md:text-5xl mb-6 text-accent" style={{fontFamily: "'Suez One'"}}>
                  Feira Agrobrasília
                </h2>
                <p className="text-base md:text-lg mb-4" style={{lineHeight: "1.6"}}>
                  A AgroBrasília é o principal evento do agronegócio do Centro-Oeste, promovendo a 
                  conexão entre tecnologia, inovação e produtores rurais.
                </p>
                <p className="text-base md:text-lg mb-4" style={{lineHeight: "1.6"}}>
                  Realizada pela COOPA-DF, a feira reúne as mais recentes soluções para o campo, desde 
                  maquinários e insumos até tecnologias para a agricultura de precisão e a produção 
                  sustentável.
                </p>
                <p className="text-base md:text-lg mb-4" style={{lineHeight: "1.6"}}>
                  Com uma programação diversificada, a AgroBrasília oferece palestras, cursos e debates 
                  sobre os principais desafios e oportunidades do setor, além de uma área dedicada à 
                  agricultura familiar.
                </p>
                <p className="text-base md:text-lg" style={{lineHeight: "1.6"}}>
                  A feira é o espaço ideal para negócios, networking e atualização profissional, 
                  contando sempre com a nossa presença.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Experiências Exclusivas */}
        <section className="py-16 md:py-24 bg-secondary text-secondary-foreground">
          <div className="container">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl md:text-5xl mb-6 text-accent" style={{fontFamily: "'Suez One'"}}>
                  Experiências Exclusivas
                </h2>
                <p className="text-base md:text-lg mb-4" style={{lineHeight: "1.6"}}>
                  As Experiências Exclusivas são momentos especialmente curados para nossos clientes e parceiros, 
                  onde criamos oportunidades de networking estratégico e troca de conhecimento entre produtores, 
                  especialistas e líderes do agronegócio.
                </p>
                <p className="text-base md:text-lg mb-4" style={{lineHeight: "1.6"}}>
                  Nesses encontros, compartilhamos informações atualizadas sobre as tendências do mercado, 
                  inovações tecnológicas e práticas sustentáveis que podem ampliar significativamente o conhecimento 
                  e a produtividade da sua operação agrícola.
                </p>
                <p className="text-base md:text-lg" style={{lineHeight: "1.6"}}>
                  Acreditamos que o conhecimento compartilhado é a base para o crescimento mútuo. Por isso, 
                  nossas experiências exclusivas são projetadas para conectar você com profissionais que entendem 
                  os desafios do campo e podem contribuir para o sucesso e a sustentabilidade do seu negócio.
                </p>
              </div>
              
              <div className="flex justify-center">
                <iframe loading="lazy"
                  width="100%"
                  height="400"
                  src="https://www.youtube.com/embed/X0jT6cR2FJA"
                  title="Experiências Exclusivas"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{borderRadius: '12px', maxWidth: '500px'}}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Benefícios */}
        <section className="py-16 md:py-24 bg-background">
          <div className="container">
            <h2 className="text-4xl md:text-5xl mb-12 text-primary text-center" style={{fontFamily: "'Suez One'"}}>
              Por que participar dos nossos eventos?
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Card 1 - Seiva */}
              <Card 
                className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30  transition-all duration-300 hover:scale-105 cursor-pointer"
                style={{
                  backgroundColor: hoveredCard === 'conhecimento' 
                    ? 'rgba(29, 134, 73, 0.35)' 
                    : 'rgba(29, 134, 73, 0.15)',
                  borderRadius: '12px',
                  border: '2px solid #1D8649'
                }}
                onMouseEnter={() => setHoveredCard('conhecimento')}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <CardContent className="p-6">
                  <h3 className="text-xl md:text-2xl font-semibold mb-3" style={{fontFamily: "'Suez One'", color: '#1D8649'}}>
                    Conhecimento Atualizado
                  </h3>
                  <p className="text-base text-muted-foreground" style={{lineHeight: "1.6"}}>
                    Acesso a palestras com especialistas do mercado, trazendo as últimas tendências 
                    e informações estratégicas para sua tomada de decisão.
                  </p>
                </CardContent>
              </Card>

              {/* Card 2 - Aurora */}
              <Card 
                className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30  transition-all duration-300 hover:scale-105 cursor-pointer"
                style={{
                  backgroundColor: hoveredCard === 'networking' 
                    ? 'rgba(211, 214, 85, 0.35)' 
                    : 'rgba(211, 214, 85, 0.15)',
                  borderRadius: '12px',
                  border: '2px solid #D3D655'
                }}
                onMouseEnter={() => setHoveredCard('networking')}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <CardContent className="p-6">
                  <h3 className="text-xl md:text-2xl font-semibold mb-3" style={{fontFamily: "'Suez One'", color: '#D3D655'}}>
                    Networking Qualificado
                  </h3>
                  <p className="text-base text-muted-foreground" style={{lineHeight: "1.6"}}>
                    Oportunidade de conhecer outros produtores, fornecedores e profissionais do 
                    agronegócio, criando conexões valiosas para seu negócio.
                  </p>
                </CardContent>
              </Card>

              {/* Card 3 - Colheita */}
              <Card 
                className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30  transition-all duration-300 hover:scale-105 cursor-pointer"
                style={{
                  backgroundColor: hoveredCard === 'novidades' 
                    ? 'rgba(199, 137, 62, 0.35)' 
                    : 'rgba(199, 137, 62, 0.15)',
                  borderRadius: '12px',
                  border: '2px solid #C7893E'
                }}
                onMouseEnter={() => setHoveredCard('novidades')}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <CardContent className="p-6">
                  <h3 className="text-xl md:text-2xl font-semibold mb-3" style={{fontFamily: "'Suez One'", color: '#C7893E'}}>
                    Novidades em Primeira Mão
                  </h3>
                  <p className="text-base text-muted-foreground" style={{lineHeight: "1.6"}}>
                    Seja um dos primeiros a conhecer os lançamentos de produtos, tecnologias e 
                    soluções que podem revolucionar sua lavoura.
                  </p>
                </CardContent>
              </Card>

              {/* Card 4 - Brisa */}
              <Card 
                className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30  transition-all duration-300 hover:scale-105 cursor-pointer"
                style={{
                  backgroundColor: hoveredCard === 'relacionamento' 
                    ? 'rgba(159, 207, 202, 0.35)' 
                    : 'rgba(159, 207, 202, 0.15)',
                  borderRadius: '12px',
                  border: '2px solid #9FCFCA'
                }}
                onMouseEnter={() => setHoveredCard('relacionamento')}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <CardContent className="p-6">
                  <h3 className="text-xl md:text-2xl font-semibold mb-3" style={{fontFamily: "'Suez One'", color: '#9FCFCA'}}>
                    Relacionamento Próximo
                  </h3>
                  <p className="text-base text-muted-foreground" style={{lineHeight: "1.6"}}>
                    Fortaleça sua parceria com a Fercci e nossos fornecedores, tendo acesso direto 
                    aos especialistas e gestores.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 md:py-24 bg-muted/30">
          <div className="container max-w-3xl text-center">
            <h2 className="text-4xl md:text-5xl mb-6 text-primary" style={{fontFamily: "'Suez One'"}}>
              Quer participar dos próximos eventos?
            </h2>
            <p className="text-lg text-muted-foreground mb-8" style={{lineHeight: "1.6"}}>
              Entre em contato conosco e garanta sua presença nos eventos exclusivos da Fercci.
            </p>
            <Link href="/contato" onClick={scrollToTop}>
              <button className="bg-accent hover:bg-accent/90 text-primary font-semibold px-8 py-4 rounded-md text-lg transition-all hover:scale-105 cursor-pointer uppercase">
                Fale conosco
              </button>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

